import {
  type Content,
  type Item,
  Portal,
  Root,
  Separator,
  Trigger,
} from '@radix-ui/react-context-menu'
import React, { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react'

import { StyledNewContextMenuContent, StyledNewContextMenuItem } from './NewContextMenu.styles'

const NewContextMenu = Root

const NewContextMenuTrigger = Trigger

const NewContextMenuSeparator = Separator

type NewContextMenuContentProps = ComponentPropsWithoutRef<typeof Content> & {
  'data-e2e'?: string
}

const NewContextMenuContent = forwardRef<ElementRef<typeof Content>, NewContextMenuContentProps>(
  ({ children, 'data-e2e': dataE2e, ...props }, ref) => (
    <Portal>
      <StyledNewContextMenuContent data-e2e={dataE2e} ref={ref} {...props}>
        {children}
      </StyledNewContextMenuContent>
    </Portal>
  )
)

type NewContextMenuItemProps = ComponentPropsWithoutRef<typeof Item> & {
  'data-e2e'?: string
}

const NewContextMenuItem = forwardRef<ElementRef<typeof Item>, NewContextMenuItemProps>(
  ({ children, 'data-e2e': dataE2e, ...props }, ref) => (
    <StyledNewContextMenuItem data-e2e={dataE2e} ref={ref} {...props}>
      {children}
    </StyledNewContextMenuItem>
  )
)

export {
  NewContextMenu,
  NewContextMenuTrigger,
  NewContextMenuSeparator,
  NewContextMenuContent,
  NewContextMenuItem,
}
